import { useMemo } from "react";

import { QuestionPreviewNext } from "@vericus/cadmus-common";

import { QuestionFragment, QuestionType } from "@/generated/graphql";

import * as styles from "./sheet-preview.css";
import { getQuestionPreviewDataAndPromptDoc } from "./utils";

interface Props {
  questionTitle: string;
  question: QuestionFragment;
  points: number | null;
  isChildQuestion: boolean;
  correctResponseMarking: boolean;
}

/**
 * Render a Task's question in a preview only component.
 */
export function TaskBlockPreview(props: Props) {
  const {
    question,
    questionTitle,
    isChildQuestion,
    points,
    correctResponseMarking
  } = props;

  const { promptDoc, questionData } = useMemo(
    () =>
      question
        ? getQuestionPreviewDataAndPromptDoc(question, points)
        : { promptDoc: null, questionData: null },
    [question, points]
  );

  if (!question || !questionData) return null;

  const previewMode = correctResponseMarking ? "response" : "question";
  const automarkDisplay = correctResponseMarking ? "badge" : undefined;

  return (
    <QuestionPreviewNext
      questionId={question.id}
      data={questionData}
      questionTitle={questionTitle}
      withHeader={question.questionType !== QuestionType.Overview}
      promptDoc={promptDoc}
      className={isChildQuestion ? styles.childquestion : undefined}
      mode={previewMode}
      automarkDisplay={automarkDisplay}
    />
  );
}
